<template>
  <div class="wrap-options" @mouseleave="handleMouseleave">
    <b-button-group vertical v-if="isShow">
      <b-button variant="options" @click="reply">Reply</b-button>
      <b-button variant="options" @click="hide">Close</b-button>
    </b-button-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false
    };
  },
  methods: {
    show() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
      this.$emit("hide");
    },
    reply() {
      this.$emit("reply");
    },
    handleMouseleave() {
      this.isShow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap-options {
  position: absolute;
  bottom: 0px;
  right: 10px;
  width: 100px;
  border-radius: 4px;
  .btn-group-vertical {
    border-radius: 4px;
    border: 1px solid #e4e4e4;
    width: 100%;
    .btn-options:hover {
      background-color: #eeeeee;
    }
    .btn-options {
      background-color: white;
      width: 100%;
      text-align: left;
      color: #9c9c9c;
      font-size: 14px;
      padding: 0.3rem 0.5rem;
    }
  }
}
.user .wrap-options {
  left: 10px;
}
</style>
